import { render, staticRenderFns } from "./hazardEquipmentClassDetail.vue?vue&type=template&id=40e37e5d"
import script from "./hazardEquipmentClassDetail.vue?vue&type=script&lang=js"
export * from "./hazardEquipmentClassDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40e37e5d')) {
      api.createRecord('40e37e5d', component.options)
    } else {
      api.reload('40e37e5d', component.options)
    }
    module.hot.accept("./hazardEquipmentClassDetail.vue?vue&type=template&id=40e37e5d", function () {
      api.rerender('40e37e5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/mim/hazardEquipment/hazardEquipmentClassDetail.vue"
export default component.exports